require.register("resources/assets/coffee/Grower/handlers/contacts/tabs/Confirm_Tab_Handler", function(exports, require, module){
  $0
  
});

